import { render, staticRenderFns } from "./RegistroNuevaAuditoriaDialogComponent.vue?vue&type=template&id=8f05ed3c"
import script from "./RegistroNuevaAuditoriaDialogComponent.vue?vue&type=script&lang=js"
export * from "./RegistroNuevaAuditoriaDialogComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports